import { useCallback, useState } from 'react';

export interface ShowMoreControls {
  expanded: boolean;
  show: () => void;
  hide: () => void;
  toggle: () => void;
}

export const useShowMore = (initial = false): ShowMoreControls => {
  const [expanded, setExpanded] = useState(initial);
  const show = useCallback(() => setExpanded(true), []);
  const hide = useCallback(() => setExpanded(false), []);
  const toggle = useCallback(() => setExpanded((prev) => !prev), []);

  return { expanded, show, hide, toggle };
};
